<div *ngIf="!isMobile()">
  <div *ngIf="COD_EMPRESA=='NXVCARGUI'" class="col-12 pt-1" style="width: 80%;">
    <figure class="figure logo">
      <img class="figure-img img-fluid" src="{{logoMenu.src}}" alt="{{logoMenu.alt}}" >
    </figure>
  </div>
  <div class="row container-email">

    <div class="col-12">
      <!-- <div class="row align-items-end container-logo">
        <div class="col-12 pt-1">
          <figure class="figure logo">
            <img class="figure-img img-fluid" src="{{logoMenu.src}}" alt="{{logoMenu.alt}}" >
          </figure>
        </div> -->
        <!-- <div *ngIf="versionFlag" class="col-lg-12 pt-1 bg-primary btn" style="cursor: pointer;">
          <a class="text-justify " (click)="actualizar()">
            <div class="text-center">ACTUALIZAR
            </div>
          </a>
        </div> -->
      <!-- </div> -->
      <section class="user-section">
        <figure class="user-figure" (click)="perfilUsuario(perfilUsuarioModal)">
          <img alt="Usuario" class="imgUsuario" style="cursor: pointer; border-radius: 50%;" [src]="defaultC.fullImagePath"            (error)="onImgError($event)">
        </figure>
        <div class="user-data" (click)="perfilUsuario(perfilUsuarioModal)">
          <p placement="bottom" style="cursor: pointer;" tooltip="{{usuario}}">{{usuario}}</p>
          <!-- <p placement="bottom" style="cursor: pointer;" [popover]="popTemplate" tooltip="{{usuario}}" #pop="bs-popover">{{usuario}}</p> -->
        </div>
        <div class="user-option">
        </div>
      </section>
    </div>
  </div>
  <ng-template #popTemplate>
    <fa-icon [icon]="['fas', 'sign-out-alt']" (click)="cerrarSesion(template, 7)" style="cursor: pointer;"></fa-icon>
    <a (click)="cerrarSesion(template, 7)" style="cursor: pointer;">Cerrar Sesión</a>
  </ng-template>
  <div class="row menu-options container-menu">
    <div class="col-12">
      <!-- <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <a *ngFor="let option of listaMenu; index as i" [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }"
          class="nav-link option-{{option.id}}" [routerLink]="option.id == '7' ? null : option.route" data-toggle="pill"
          role="tab" aria-controls="v-pills-home" aria-selected="true" (click)="cerrarSesion(template, option.id)">{{option.descripcion}}
          <i class="material-icons menu-icon">{{option.icon}}</i>
        </a>
        <div class="nav-link version">{{version}}</div>
      </div> -->
      <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">

        <ng-container *ngFor="let option of listaMenu; index as i">
          <a *ngIf="(
            (option.route == 'usuarios' || option.route == 'tracking-conductores' || option.route == 'ofertar-servicios' || option.route == 'Restringir-Servicio' || option.route == 'cargo-aeropuerto')
            && (((data.IdEmpresa == 128 || data.IdEmpresa == 13361) && data.Rol == 13) || data.Rol == 1)
          ) ||
          (
            (option.route == 'tracking-conductores' || option.route == 'ofertar-servicios' || option.route == 'configuracion-despachador' || option.route == 'reporte-personalizado')
            && (((data.IdEmpresa == 13361 || data.IdEmpresa == 128) && data.Rol == 13) || data.Rol == 1)
          ) ||
          (
            (option.route == 'configuracion-despachador')
            && (data.Rol == 1 || data.Rol == 5)
          ) ||
          (
            (option.route == 'usuarios')
            && (data.Rol == 1 || data.Rol == 5)
          ) ||
          (
            (option.route == 'tracking-conductores')
            && ((data.IdEmpresa == 13235 || data.IdEmpresa == 13102) && data.Rol == 5)
          ) ||
          (
            option.route == 'mapa-de-calor' && (((data.IdEmpresa == 128 || data.IdEmpresa == 13361) && data.Rol == 13) || data.Rol == 1)
          )" [routerLink]="option.id != 7 ? [option.route] : []"
          [routerLinkActive]="option.id != 7 ? ['router-link-active']: []"
          [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }" class="nav-link option-{{option.id}}"
          data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
          (click)="cerrarSesion(template, option.id)">
            {{option.descripcion}}
            <i class="material-icons menu-icon">{{option.icon}}</i>
          </a>
          <a *ngIf="option.route != 'comision-reducida'
            && option.route != 'bono'
            && option.route != 'reporte-bono'
            && option.route != 'promociones'
            && option.route != 'reporte-promociones'
            && option.route != 'registro-promociones'
            && option.route != 'reporte-estrellas'
            && option.route != 'usuarios'
            && option.route != 'tracking-conductores'
            && option.route != 'cargar-datos'
            && option.route != 'eliminar-datos'
            && option.route != 'configuracion-despachador'
            && option.route != 'mapa-de-calor'
            && option.route != 'ofertar-servicios'
            && option.route != 'reporte-rechazo'
            && option.route != 'reporte-personalizado'
            && option.route != 'tasa-de-cancelacion'
            && option.route != 'reporte-proxima-conexion'
            && option.route != 'cargar-usuarios'
            && option.route != 'actualizar-usuarios'
            && option.route != 'Restringir-Servicio'
            && option.route != 'cargo-aeropuerto'
            && option.route != 'recargo-reserva'" [routerLink]="option.id != 7 ? [option.route] : []"
          [routerLinkActive]="option.id != 7 ? ['router-link-active']: []"
          [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }" class="nav-link option-{{option.id}}"
          data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
          (click)="cerrarSesion(template, option.id)">
            {{option.descripcion}}
            <i class="material-icons menu-icon">{{option.icon}}</i>
          </a>

          <ng-container *ngIf="cargaMasiva.has == true && option.Orden == cargaMasiva.order && cargaMasiva.permission == true">
            <accordion>
              <accordion-group (isOpenChange)="log($event)">
                <div accordion-heading>
                  Carga Masiva 
                  <i class="material-icons menu-icon" style="color: black; vertical-align: middle;">arrow_drop_down</i>
                </div>
                <ng-container *ngFor="let option2 of listaMenu">
                  <a *ngIf="option2.route == 'cargar-datos'
                  || option2.route == 'eliminar-datos'" class="nav-link option-{{option2.id}}"
                  [routerLink]="[option2.route]" [routerLinkActive]="['router-link-active']"
                  data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
                  >
                    {{option2.descripcion}}
                  <i class="material-icons menu-icon">{{option2.icon}}</i>
                </a>
                </ng-container>
              </accordion-group>
           </accordion>
          </ng-container>

          <ng-container *ngIf="beneficiosConductor.has == true && option.Orden == beneficiosConductor.order && beneficiosConductor.permission == true">
            <accordion>
              <accordion-group (isOpenChange)="log($event)">
                <div accordion-heading>
                  Beneficios<br>Conductor 
                  <i class="material-icons menu-icon" style="color: black; vertical-align: middle;">arrow_drop_down</i>
                </div>
                <ng-container *ngFor="let option2 of listaMenu">
                  <a *ngIf="option2.route == 'comision-reducida'
                  || option2.route == 'bono'
                  || option2.route == 'reporte-bono'
                  || option2.route == 'reporte-estrellas'" class="nav-link option-{{option2.id}}"
                  [routerLink]="[option2.route]" [routerLinkActive]="['router-link-active']"
                  data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
                  >
                    {{option2.descripcion}}
                  <i class="material-icons menu-icon">{{option2.icon}}</i>
                </a>
                </ng-container>
              </accordion-group>
           </accordion>
          </ng-container>

          <ng-container *ngIf="reporteDeConductores.has == true && option.Orden == reporteDeConductores.order && reporteDeConductores.permission == true">
            <accordion>
              <accordion-group (isOpenChange)="log($event)">
                <div accordion-heading>
                  Reporte de<br>Conductores
                  <i class="material-icons menu-icon" style="color: black; vertical-align: middle;">arrow_drop_down</i>
                </div>
                <ng-container *ngFor="let option3 of listaMenu">
                  <a *ngIf="option3.route == 'reporte-rechazo'
                  || option3.route == 'tasa-de-cancelacion'
                  || option3.route == 'reporte-proxima-conexion'" class="nav-link option-{{option3.id}}"
                  [routerLink]="[option3.route]" [routerLinkActive]="['router-link-active']"
                  data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
                  >
                    {{option3.descripcion}}
                  <i class="material-icons menu-icon">{{option3.icon}}</i>
                </a>
                </ng-container>
              </accordion-group>
           </accordion>
          </ng-container>

          <ng-container *ngIf="promos.has == true && option.Orden == promos.order && promos.permission == true">
            <accordion>
              <accordion-group (isOpenChange)="log($event)">
                <div accordion-heading>
                  Promociones 
                  <i class="material-icons menu-icon" style="color: black; vertical-align: middle;">arrow_drop_down</i>
                </div>
                <ng-container *ngFor="let option2 of listaMenu">
                  <a *ngIf="option2.route == 'promociones'
                  || option2.route == 'registro-promociones'
                  || option2.route == 'reporte-promociones'" class="nav-link option-{{option2.id}}"
                  [routerLink]="[option2.route]" [routerLinkActive]="['router-link-active']"
                  data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
                  >
                    {{option2.descripcion}}
                  <i class="material-icons menu-icon">{{option2.icon}}</i>
                </a>
                </ng-container>
              </accordion-group>
           </accordion>
          </ng-container>

          <ng-container *ngIf="cargaMasivaUsuarios.has == true && option.Orden == cargaMasivaUsuarios.order && cargaMasivaUsuarios.permission == true">
            <accordion>
              <accordion-group (isOpenChange)="log($event)">
                <div accordion-heading>
                  Carga Usuarios
                  <i class="material-icons menu-icon" style="color: black; vertical-align: middle;">arrow_drop_down</i>
                </div>
                <ng-container *ngFor="let option2 of listaMenu">
                  <a *ngIf="option2.route == 'cargar-usuarios'
                  || option2.route == 'actualizar-usuarios'" class="nav-link option-{{option2.id}}"
                  [routerLink]="[option2.route]" [routerLinkActive]="['router-link-active']"
                  data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
                  >
                    {{option2.descripcion}}
                  <i class="material-icons menu-icon">{{option2.icon}}</i>
                </a>
                </ng-container>
              </accordion-group>
           </accordion>
          </ng-container>

          <ng-container *ngIf="cargoNoComisionable.has == true && option.Orden == cargoNoComisionable.order && cargoNoComisionable.permission == true">
            <accordion>
              <accordion-group (isOpenChange)="log($event)">
                <div accordion-heading>
                  Cargo no comisionable
                  <i class="material-icons menu-icon" style="color: black; vertical-align: middle;">arrow_drop_down</i>
                </div>
                <ng-container *ngFor="let optionCNC of listaMenu">
                  <a *ngIf="optionCNC.route == 'recargo-reserva'" class="nav-link option-{{optionCNC.id}}"
                  [routerLink]="[optionCNC.route]" [routerLinkActive]="['router-link-active']"
                  data-toggle="pill" style="cursor:pointer" role="tab" aria-controls="v-pills-home" aria-selected="true"
                  >
                    {{optionCNC.descripcion}}
                  <i class="material-icons menu-icon">{{optionCNC.icon}}</i>
                </a>
                </ng-container>
              </accordion-group>
           </accordion>
          </ng-container>

        </ng-container>
      
        <div class="nav-link version">{{version}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="COD_EMPRESA!='NXVCARGUI'" class="row align-items-end container-logo">
    <div class="col-12 pt-1">
      <figure class="figure logo" [ngStyle]="{width : logoMenu.width + 'px'}"  >
        <img class="figure-img img-fluid" src="{{logoMenu.src}}" alt="{{logoMenu.alt}}">
      </figure>
    </div>
    <div *ngIf="versionFlag" class="col-lg-12 pt-1 bg-primary btn" style="cursor: pointer;">
      <a class="text-justify " (click)="actualizar()">
        <div class="text-center">ACTUALIZAR
        </div>
      </a>
    </div>
  </div>
</div>

<!-- Mobile View -->
<div *ngIf="isMobile()">
  <div class="pos-f-t">
    <div [@slideInOut]="state" id="menu-navigation">
      <div class="p-4">
        <div style="display:flex;  justify-content: space-between;">
          <figure class="img-fluid rounded-circle user-image mb-0">
            <img alt="Usuario" class="imgUsuario"  [src]="defaultC.fullImagePath" (error)="onImgError($event)"
              data-holder-rendered="true"
              style="width: 50px; height: 50px; border-radius: 50%;">

          </figure>
          <div class="row">

            <div style="display:flex; align-items: center; padding-left:18px; padding-right: 20px ">
              <p>{{usuario}}</p>
            </div>


          </div>
          <div class="float-right text-center">
            <figure class="figure mb-0">
              <img class="figure-img img-fluid" src="{{logo.src}}" alt="{{logo.alt}}" width="{{logo.width}}">
            </figure>
          </div>

        </div>
        <hr>
        <div class="row">
          <div class="col-12">
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <a *ngFor="let option of listaMenu; index as i"
                [ngClass]="{'cerrar-sesion': option.id == 7, 'active' : i == 0 }"
                class="nav-link option-{{option.id}} {{option.route}}"
                [routerLink]="option.id == '7' ? null : option.route" data-toggle="pill" role="tab"
                aria-controls="v-pills-home" aria-selected="true"
                (click)="cerrarSesion(template, option.id)">{{option.descripcion}}
                <i class="material-icons menu-icon">{{option.icon}}</i>
              </a>
              <div class="nav-link version">{{version}}</div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- (click)="isCollapsed = !isCollapsed" -->
    <nav class="navbar navbar-light">
      <button style="width: 55px;" class="navbar-toggler menu-mobile-button" (click)="toggleState()" type="button"
        data-toggle="collapse" data-target="#menu-navigation" aria-controls="menu-navigation" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <figure class="float-right mb-0" [ngClass]="state === 'in' ? 'ocultar-logo-mobile' : ''">
        <img src="{{logo.src}}" alt="{{logo.alt}}" width="{{logo.width}}">
      </figure>
    </nav>
  </div>
</div>

<ng-template #template>
  <div class="modal-body text-center" style="height: 100px !important; max-height: 150px !important;">
    <p>
      <span>¿Estás seguro que desea cerrar su sesión en {{NOMBRE_EMPRESA}}?</span>
    </p>
  </div>
  <div class="row">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-primary m-2" (click)="logout()">Sí</button>
      <button type="button" class="btn btn-default m-2" (click)=" decline()">No</button>
    </div>
  </div>
</ng-template>


<ng-template #perfilUsuarioModal>
  <div class="modal-header">
    <div>
      <figure class="user-figure">
        <img alt="Usuario" style="cursor: pointer; border: 10px solid black" [src]="defaultC.fullImagePath"
          onError="this.src='assets/usuario.png'">
      </figure>
      <div class="user-data">
        <!-- <p placement="bottom" class="perfil_sel text-primary"> {{data.Email}}</p> -->
        <p placement="bottom" class="perfil_sel text-primary"> {{usuario}}</p>
      </div>
    </div>
  </div>
  <div class="modal-body text-center">
    <div class="row" style="margin-top: 15px; margin-bottom: 15px;" *ngFor="let asociado of lstAsociado; index as i"
      (click)="cambiarCuenta(asociado)">
      <figure class="user-figure">
        <img alt="Usuario" style="cursor: pointer;" [src]="asociado.url" onError="this.src='assets/usuario.png'">
      </figure>
      <div class="user-data">
        <p placement="bottom" style="cursor: pointer;">{{asociado.correo}}</p>
      </div>
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-primary" (click)="logout()">Sí</button> -->
    <button type="button" class="btn btn-default" (click)="modalPerfil.hide()">Cerrar</button>
  </div>
</ng-template>
<app-modal-carga></app-modal-carga>
